import type { ExportEscalation } from '~/api/internal';

export const EXPORT_ESCALATION_POLL_INTERVAL_MS = 10_000;

export const EXPORT_ESCALATION_REASON_CONFIG: Record<
  ExportEscalation['escalationReason'],
  { tabLabel: string; dialogTitle: string; runButtonLabel: string }
> = {
  restricted: {
    tabLabel: 'Restricted',
    dialogTitle: 'Restricted Export Request',
    runButtonLabel: 'Run Export',
  },
  failed: {
    tabLabel: 'Failed',
    dialogTitle: 'Failed Export Request',
    runButtonLabel: 'Retry',
  },
};
